export default "__VITE_ASSET__dc25a116__"